export default __webpack_public_path__ + "static/media/defaultjohn.94a9567d.png";